import {
  RiApps2Line,
  RiArchiveStackLine,
  RiBankLine,
  RiBillLine,
  RiCalculatorLine,
  RiContactsBook2Line,
  RiEraserLine,
  RiFileSearchLine,
  RiFileTransferLine,
  RiFlagLine,
  RiGlobalLine,
  RiHandCoinLine,
  RiLayoutColumnLine,
  RiLayoutLine,
  RiMagicLine,
  RiPaletteLine,
  RiPuzzle2Line,
  RiShoppingBag3Line,
  RiShoppingCart2Line,
  RiTaskLine,
  RiTeamLine,
  RiToolsLine,
} from '@remixicon/react';
import type { RemixiconComponentType } from '@remixicon/react';

/**
 * La part propre à Odoo du vocabulaire d'icônes de l'application
 * (`components/ui/icons/waadooIcons.ts`), mise à part à l'étape 9c du plan
 * « plateforme d'applications » pour rejoindre le module Odoo (étape 9e).
 * Même règle : une notion, une icône ; mêmes noms qu'avant la séparation.
 */
export const odooIcons = {
  /** The Odoo applications enabled in a project (Ventes, Facturation…). */
  odooApps: RiApps2Line,
  /** Odoo modules other than applications (Waadoo, OCA). */
  odooModules: RiPuzzle2Line,
  /** Odoo applications and module families, one notion each. */
  odooSales: RiShoppingCart2Line,
  odooPurchase: RiShoppingBag3Line,
  odooInvoicing: RiBillLine,
  odooInventory: RiArchiveStackLine,
  odooCrm: RiHandCoinLine,
  odooProject: RiTaskLine,
  odooContacts: RiContactsBook2Line,
  odooManufacturing: RiToolsLine,
  odooEmployees: RiTeamLine,
  odooWebsite: RiGlobalLine,
  odooLocalisation: RiFlagLine,
  odooEInvoicing: RiFileTransferLine,
  odooAccounting: RiCalculatorLine,
  odooSepa: RiBankLine,
  odooComfort: RiMagicLine,
  odooAudit: RiFileSearchLine,
  odooInterface: RiLayoutLine,
  odooDebranding: RiEraserLine,
  odooTheme: RiPaletteLine,
  odooSplitView: RiLayoutColumnLine,
} as const satisfies Record<string, RemixiconComponentType>;
